import React, { useState } from 'react';

const TIMER_PRESETS = [0, 1, 2, 5, 10, 20]; // minutes; 0 = no timer

// Shown once per fresh launch, after the intro. Lets the user pick an optional
// session length before the orbs. Choosing nothing (No timer) is fine.
const TimerScreen = ({ initialMinutes = 0, onBegin }) => {
  const [minutes, setMinutes] = useState(initialMinutes);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6 overflow-y-auto">
      <div className="max-w-md w-full bg-white/5 backdrop-blur-lg p-8 rounded-3xl border border-white/10 shadow-2xl text-center">
        <h1 className="text-3xl font-bold text-white mb-2 tracking-tight">Set a session length?</h1>
        <p className="text-gray-400 text-sm mb-8">
          Optional — a gentle chime marks the end. You can change this anytime in settings.
        </p>

        <div className="grid grid-cols-3 gap-3 mb-8">
          {TIMER_PRESETS.map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => setMinutes(m)}
              className={`py-3 rounded-2xl text-base font-bold transition-colors border ${
                minutes === m
                  ? 'bg-blue-500/40 text-blue-100 border-blue-400/40'
                  : 'bg-white/5 text-white/60 border-transparent hover:bg-white/10'
              }`}
            >
              {m === 0 ? 'No timer' : `${m} min`}
            </button>
          ))}
        </div>

        <button
          onClick={() => onBegin(minutes)}
          className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white p-4 rounded-2xl font-bold transition-all transform active:scale-95 shadow-lg shadow-purple-500/25"
        >
          Begin
        </button>
      </div>
    </div>
  );
};

export default TimerScreen;
